<template>
    <el-dialog :close-on-click-modal="false" :title="title" :visible="digVisible" width="756px" @close="closeDig"
        destroy-on-close>
        <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
        </OrganDialog>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
            <el-form-item label="组织结构" prop="structure_2">
                <el-input v-model="selectName" placeholder="请选择" style="width:562px;" @focus="dialogOpen"
                    @clear="handeleClear" clearable></el-input>
            </el-form-item>
            <el-form-item :label="`所属${$store.state.themeTitle}室`" prop="training_room_id">
                <el-select v-model="ruleForm.training_room_id" clearable filterable :placeholder="`请选择`"
                    @change="handleTargetChange" style="width: 216px;">
                    <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="化学品" prop="product_id">
                <el-select v-model="ruleForm.product_id" clearable filterable :placeholder="`请选择`" style="width: 216px;"
                    @change="handleChemicalChange">
                    <el-option v-for="item in chemicals" :key="item.id" :label="item.name" :value="item.id"
                        :disabled="item.current_stock * 1 == 0">
                        <p>{{ item.name }}</p>
                        <p v-if="item.current_stock" class="el-option-tips">当前库存：{{ item.current_stock }}</p>
                        <p v-if="item.category" class="el-option-tips">分类：{{ item.category }}</p>
                        <p v-if="item.unit" class="el-option-tips">单位：{{ item.unit }}</p>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="领用人" prop="lyr">
                <el-input v-model="ruleForm.lyr" placeholder="请输入" style="width:216px;"></el-input>
            </el-form-item>
            <!-- <el-form-item label="出库数量" prop="quantity">
                <el-input v-model="ruleForm.quantity" @input="inputNumber" clearable placeholder="请输入"
                    style="width:216px;"></el-input>
            </el-form-item> -->
            <el-form-item label="出库时间" prop="date">
                <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间"
                    v-model="ruleForm.date" style="width:206px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="用途" prop="usage">
                <el-input type="textarea" v-model="ruleForm.usage" placeholder="请输入" style="width:562px;" :rows="4">
                </el-input>
            </el-form-item>
            <div class="add_win">
                <div v-for="(item, index) in ruleForm.items" :key="index" class="add_win_body el-form">
                    <el-form-item label="化学品" :prop="`items[${index}].chemical_item_id`">
                        <el-select v-model="item.chemical_item_id" clearable filter placeholder="请选择"
                            style="width:196px;" @change="handleChemicalItemChange($event, item)">
                            <el-option v-for="(chem, index) in chemicalItems" :disabled="item.current_stock * 1 == 0"
                                :key="index" :label="chem.item_code" :value="chem.id">
                                <p>化学品编号：{{ chem.item_code }}</p>
                                <p v-if="chem.current_quantity" style=" color: #8492a6; font-size: 13px">当前库存：{{
                                    chem.current_quantity }}</p>
                                <p v-if="chem.unit" style=" color: #8492a6; font-size: 13px">单位：{{ chem.unit }}</p>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出库数量" :prop="`items[${index}].quantity`">
                        <el-input-number v-model="item.quantity" :precision="1" :step="0.1" :min="0"
                            :max="item.current_quantity ? item.current_quantity * 1 : 0" style="width:196px;">
                        </el-input-number>
                    </el-form-item>
                    <div class="add_win_del">
                        <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
                    </div>
                </div>
                <div class="add_win_add">
                    <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
                </div>
            </div>
            <el-form-item style="margin-top:8px;width:100%;text-align:right;">
                <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
    props: ['digVisible'],
    mixins: [mixinOrgan, mixinList, mixinValidate],
    data() {
        return {
            ruleForm: {
                "structure_1": "",
                "structure_2": "",
                "product_id": "",
                "quantity": 0,
                "lyr": "",
                "training_room": "",
                "training_room_id": "",
                "usage": "",
                "date": "",
                "record_number": "",
                "apply_id": "",
                items: [{ chemical_item_id: '', quantity: 0 }]
            },
            kc: 0,
            selectName: '',
            levell: [1, 2],
            rules: {
            },
            rulesRoot: {
                training_room_id: [{ required: true, message: '请选择', trigger: 'change' }],
                structure_2: [{ required: true, message: '请选择院系专业' }],
                product_id: [{ required: true, message: '请选择', trigger: 'change' }],
                date: [{ required: true, message: '请选择', trigger: 'change' }],
                quantity: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { validator: this.checkfloat, trigger: 'blur' },
                ],
                usage: [{ required: true, message: '请输入', trigger: 'blur' }],
                lyr: [{ required: true, message: '请输入', trigger: 'blur' }],
            },
            chemicals: [],
            chemicalItems: [],
            needQuery: false
        };
    },
    watch: {

        'ruleForm.items': {
            handler: function (val) {
                this.ruleForm.quantity = 0
                val.forEach(item => {
                    this.ruleForm.quantity += item.quantity ? item.quantity : 0;
                })
            },
            deep: true,
        },
    },
    mounted() {
        this.setRules()
    },
    methods: {

        setRules() {
            this.rules = {
                ...this.rulesRoot,
                ...this.generateArrRules()
            };
        },
        handleItemDelete(item, index) {
            this.ruleForm.items.splice(index, 1);
        },

        handleItemAdd() {
            this.ruleForm.items.push({ chemical_item_id: '', quantity: 0, current_quantity: 0 });
            this.setRules();
        },
        async getChemicalsItems(id) {
            if (!id) {
                this.chemicalItems = []
                return
            }
            let res = await this.$api.instance.interfaceServer(`api/chemical/info/items/${id}`, 'get', { page: 1, size: 9999 });
            if (res.code == 0 && res.data) {
                this.chemicalItems = res.data.data ? res.data.data : []
                // this.curChems = this.$until.easyDeepCopy(this.chemicals)
            }
        },
        generateArrRules() {
            const arrRules = {};
            this.ruleForm.items.forEach((item, index) => {
                arrRules[`items[${index}].quantity`] = [
                    { required: true, message: `请输入`, trigger: 'blur' },
                    { validator: this.checkfloat, trigger: 'blur' }
                ];
                arrRules[`items[${index}].chemical_item_id`] = [
                    { required: true, message: `请选择`, trigger: 'change' }
                ];
            });
            return arrRules;
        },
        inputNumber(val) {
            if (val > this.kc) {
                this.$message.error("输入数量不能大于库存数量")
                this.ruleForm.quantity = 0
            }
        },
        hanldAdd() {
            this.type = 'add'
            this.title = "新增"
            if (this.selectName) {
                this.selectName = ''
            }
            this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
            this.$nextTick(() => {
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.clearValidate()
                }
            });
            this.getChemicals()
        },

        handleEditNew(row, extraKeys = ['id']) {
            this.type = 'edit'
            this.title = "编辑"
            this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
            this.ruleForm = this.assignFormObj(this.ruleForm, row, extraKeys)
            this.handleEditInit(row)
        },
        async handleEditInit(row) {
            this.handleEditCallBackSetStruc({ major: 'structure_2', dep: 'structure_1', row: row })
            await this.getChemicals()
            this.handleChemicalChange(row.product_id, row.quantity )
        },
        handleChemicalChange(val, quantity = 0) {
            const { current_stock } = this.$until.getLabelNameNew({ arr: this.chemicals, id: val })
            this.kc = current_stock * 1
            this.ruleForm.quantity = quantity
            this.getChemicalsItems(val)
        },

        handleChemicalItemChange(val, item) {
            const { current_quantity } = this.$until.getLabelNameNew({ arr: this.chemicalItems, id: val })
            item.current_quantity = current_quantity;
            if (this.ruleForm.items.filter(item => item.chemical_item_id === val).length > 1) {
                this.$message({
                    type: 'error',
                    center: true,
                    message: '该化学品已选择！',
                });
                item.chemical_item_id = '';
            }

        },
        getOrganList() {
            this.beforeGetOrgan({ limit: false, major: "structure_2", dep: 'structure_1' });

        },
        handleTargetChange(val) {
            const { training_name, training_no } = this.$until.getLabelNameNew({ arr: this.$store.state.trainRooms, id: val })
            this.ruleForm.training_room = training_name;
            this.ruleForm.training_no = training_no;
        },
        async createMethod() {
            let params = this.$until.deleteNullPrototype(this.ruleForm);
            params.record_number = new Date().getTime() + ''
            let res = await this.$api.instance.interfaceServer('api/chemical/record/createUpdate', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '提交成功！',
                });
                this.closeDig(true);

            }
        },
        async getChemicals() {
            let res = await this.$api.instance.interfaceServer('api/chemical/info/list', 'get', { page: 1, size: 9999 });
            if (res.code == 0 && res.data) {
                this.chemicals = res.data.data;
            }
        },
        closeDig(flag) {
            this.$emit('closeDig', flag);
        },
        async handleChangeRoom(val) {
            await this.$store.dispatch('getConsum', { training_room: val });
        },
        handleUseChange(val) {
            if (val != '教学') {
                this.ruleForm.course_name = ''
                this.ruleForm.student_num = ''
            }
        },
        handleComsumeChange(val) {
            console.log(val, this.$store.state.consumeIntos);
            this.ruleForm.name = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'name', val);
            this.ruleForm.number = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'number', val);
            this.ruleForm.price = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'price', val);
            const consumNumber = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'remainder_quantity', val);
            this.consumNumber = consumNumber ? consumNumber : 0;
        },
        resetForm(formName) {
            this.ruleForm.name = '';
            this.ruleForm.number = '';
            this.ruleForm.price = 0;
            this.consumNumber = 0;
            this.$refs[formName].resetFields();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.createMethod();
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped></style>
